import { Observable, Subject } from 'rxjs';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import {
    MyInfoAuthInfo, MyInfoAuthUrlResponse, MyInfoUpdatePersonResponse, SingpassMyinfoCodeReference,
    SingpassMyinfoValidateCodeReferenceResponse
} from '@models/myinfo/myinfo.model';
import { NewRemitter, Remitter } from '@models/remitter/remitter.model';

@Injectable({
  providedIn: 'root'
})
export class MyinfoService {

  constructor(
    private httpClient: HttpClient
  ) { }
  
  protected readonly _personData = signal<any>({});
  protected readonly _state = signal('');
  protected readonly _authCode = signal('');
  private storageSubject = new Subject<string>();
  updateState(value:string) {
    this._state.set(value);
  }
  get state() {
    return this._state()
  }
  updateAuthCode(value:string) {
    this._authCode.set(value);
  }
  get authCode() {
    return this._authCode()
  }
  updatePersonData(value:any) {
    this._personData.set(value);
  }
  get personData() {
    return this._personData()
  }

  getItem(key: string): any {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(key, value);
    this.storageSubject.next(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
    this.storageSubject.next(key);
  }

  watchStorage(): Observable<string> {
    return this.storageSubject.asObservable();
  }

  requestMyInfoAuth(purpose: string): Observable<MyInfoAuthUrlResponse>  {
    return this.httpClient.get<MyInfoAuthUrlResponse>(`myinfo/auth-url?purpose=${purpose}`);
  }

  getPersonData(authData: MyInfoAuthInfo): Observable<NewRemitter> {
    return this.httpClient.post<NewRemitter>('myinfo/person', authData);
  }

  getUpdatedPersonData(authData: MyInfoAuthInfo): Observable<MyInfoUpdatePersonResponse> {
    return this.httpClient.post<MyInfoUpdatePersonResponse>('myinfo/person/update', authData);
  }

  updateCodeReference(authData: MyInfoAuthInfo): Observable<SingpassMyinfoCodeReference> {
    return this.httpClient.put<SingpassMyinfoCodeReference>('myinfo/code-reference', authData);
  }

  validateAuthCompletion(state: String, purpose: String) {
    return this.httpClient.get<SingpassMyinfoValidateCodeReferenceResponse>(`myinfo/auth/validate?state=${state}&purpose=${purpose}`);
  }
}
